import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { CHANNELS } from '@spotahome/ui-library';
import ListingTitle from '@spotahome/ui-library/src/tenant/components/ListingTitle';
import ListingChipsList from '@spotahome/ui-library/src/tenant/components/ListingChipsList';

import {
  LANDLORD_DOES_NOT_KNOW_VALUE,
  getUnavailableCopyShort
} from '../ListingEnergyCertificate/utils';
import openListingEnergyCertificateModal from '../ListingEnergyCertificate/components/ListingEnergyCertificateModal/ListingEnergyCertificateModal';

const openListingOverviewSimplifiedModal = ({
  listing,
  roomChips = [],
  propertyChips = [],
  roomNumber = null,
  energyCertificate = null,
  emissionsCertificate = null,
  fullscreenOnMobile = false
} = {}) => {
  const hasEnergyCert =
    energyCertificate?.value &&
    energyCertificate.value !== LANDLORD_DOES_NOT_KNOW_VALUE;

  const energyCertChip = hasEnergyCert
    ? {
        listing,
        name: `${trans(
          'listing.energy-certificate.title'
        )}: ${getUnavailableCopyShort(energyCertificate.value, trans)}`,
        icon: 'battery_charging_full',
        value: true,
        onClick: () =>
          openListingEnergyCertificateModal({
            energyCertificate,
            emissionsCertificate
          })
      }
    : null;

  const allPropertyChips = energyCertChip
    ? [...propertyChips, energyCertChip]
    : propertyChips;

  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: trans('listing.overview.property.title'),
    body: (
      <>
        {roomChips.length > 0 && (
          <div className="listing-overview-simplified-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.your_room_in_apartment', {
                roomNumber
              })}
            </ListingTitle>
            <ListingChipsList chipList={roomChips} />
          </div>
        )}
        {allPropertyChips.length > 0 && (
          <div className="listing-overview-simplified-modal__section">
            <ListingTitle role="tertiary">
              {trans('property_show.title.property_amenities')}
            </ListingTitle>
            <ListingChipsList chipList={allPropertyChips} />
          </div>
        )}
      </>
    ),
    fullscreenOnMobile
  });
};

export default openListingOverviewSimplifiedModal;
